import {ChangeDetectionStrategy, Component, HostListener, Input, OnChanges, OnInit, SimpleChanges} from '@angular/core';
import {ScheduleTemplateModel} from '../../../../projects/api/src/template/template.model';
import {DeviceParamModel} from '../../../../projects/api/src/device-param/device-param.model';
import {ScheduleModel} from '../../../../projects/api/src/schedule/schedule.model';
import {SemRestRequestService} from '../../../../projects/api/src/sem-rest-request/sem-rest-request.service';
import {ApiList} from '../../API/api-list.enum';
import {DialogService} from 'primeng/dynamicdialog';
import {gettext} from '../../shared/gettextMarker.function';
import {DeviceDetectorService} from 'ngx-device-detector';
import {
  ComposeTimerangePanelModalComponent
} from '../timerange-panel/compose-timerange-panel-modal/compose-timerange-panel-modal.component';
import {InsparkMessageService} from '@inspark/inspark-components';
import {ParamonApiService} from '../../../../projects/api/src/paramon/paramon-api.service';

@Component({
    selector: 'app-paramon-panel-edit',
    templateUrl: './paramon-panel-edit.component.html',
    styleUrls: ['./paramon-panel-edit.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class ParamonPanelEditComponent implements OnInit, OnChanges {
  @Input() referenceData: { deviceparam: DeviceParamModel[]; schedule: ScheduleModel[]; scheduletemplate: ScheduleTemplateModel[] };
  @Input() editableData;
  @Input() saveComplete;
  @Input() create;
  @Input() stateParams;
  public isAllowScroll = true;
  public templateData: ScheduleTemplateModel;
  public deviceParam: DeviceParamModel;
  public schedule: ScheduleModel;
  buttonLabels = {save: 'SAVE'};

  constructor(private request: SemRestRequestService,
              private paramonApi: ParamonApiService,
              private messageService: InsparkMessageService,
              private dialogService: DialogService,
              private deviceService: DeviceDetectorService
  ) {
  }

  /**
   * Инициализирует данные, полученные из WSMeta
   */
  ngOnInit() {
    if (this.stateParams.typicalconfig) {
      this.referenceData.deviceparam = this.referenceData.deviceparam.filter(
        _param => _param.deviceconnect.typicalconfig.id === this.stateParams.typicalconfig
      );
    }
    if (!this.editableData) {
      this.templateData = {
        mode: 'UNION',
        name: '',
        comment: '',
        planningareas: []
      };
      this.schedule = this.referenceData.schedule.find(_si => _si.id === this.stateParams.schedule);
      this.editableData = {locked: false};
    } else if (this.editableData.template) {
      this.templateData = this.referenceData.scheduletemplate.find(_sti => +_sti.id === +this.editableData.template.id);
      this.deviceParam = this.referenceData.deviceparam.find(_dpi => +_dpi.id === +this.editableData.deviceparam.id);
      this.schedule = this.referenceData.schedule.find(_si => +_si.id === +this.editableData.schedule.id);
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (this.stateParams.typicalconfig) {
      this.referenceData.deviceparam = this.referenceData.deviceparam.filter(
        _param => _param.deviceconnect.typicalconfig.id === this.stateParams.typicalconfig
      );
    }
    if (!this.editableData) {
      this.templateData = {
        mode: 'UNION',
        name: '',
        comment: '',
        planningareas: []
      };
      this.schedule = this.referenceData.schedule.find(_si => _si.id === this.stateParams.schedule);
      this.editableData = {locked: false};
      this.buttonLabels.save = 'CREATE';
    } else {
      this.templateData = this.referenceData.scheduletemplate.find(_sti => _sti.id === this.editableData.template.id);
      this.deviceParam = this.referenceData.deviceparam.find(_dpi => _dpi.id === this.editableData.deviceparam.id);
      this.schedule = this.referenceData.schedule.find(_si => _si.id === this.editableData.schedule.id);
      this.buttonLabels.save = 'SAVE';
    }
  }

  @HostListener('wheel', ['$event'])
  handleWheelEvent(event) {
    if (this.isAllowScroll) {
      return;
    }
    event.preventDefault();
  }
  /**
   * Сохраняет или создает данные Paramon
   */
  public save() {
    const triggerWhenSaveDone = () => {
      this.saveComplete();
      this.messageService.success('Item successfully saved');
      if (this.editableData?.id) {
        this.paramonApi.updateData(this.paramonApi.getParamon(this.editableData.id));
      }
    };

    this.request
      .baseUrlAppend(ApiList.Db, ApiList.Paramon);

    if (this.editableData && this.editableData.id) {
      this.request.updateById(this.editableData.id, {
        locked: this.editableData.locked,
        deviceparam: this.deviceParam,
        schedule: this.schedule,
        template: this.templateData
      }).subscribe(triggerWhenSaveDone.bind(this));
    } else {
      this.request.postFormData({
        locked: this.editableData.locked,
        deviceparam: this.deviceParam,
        schedule: this.schedule,
        template: this.templateData
      }).subscribe(triggerWhenSaveDone.bind(this));
    }
  }

  allowScroll(state) {
    this.isAllowScroll = state;
  }

  /**
   * Транcформирует значение поля в null, если ничего не выбрано для in-dropdown.
   *
   * @param val - текущее значение in-dropdown из $event
   * @param fieldName - названия поля в объекте value
   */
  transformEmpty(val, fieldName) {
    if (!val || val.isEmpty) {
      this[fieldName] = null;
    }
  }

  getScheduleName(isCreate: boolean): string {
    if (isCreate) {
      return 'Create';
    }
    return this.editableData.schedule.schname;
  }

  onEdit() {
    const refWindow = this.dialogService.open(ComposeTimerangePanelModalComponent, {
      data: {editableData: this.editableData, templateData: this.templateData},
      header: gettext('Select params'),
      showHeader: false,
      width: this.deviceService.isDesktop() ? '70%' : '100%',
      height: this.deviceService.isDesktop() ? '80vh' : '100vh'
    });

      refWindow.onClose.subscribe((data) => {
        if (data?.saved) {
          this.messageService.success('Item successfully saved');
        }
    });
  }
}
